export const UPDATE_TEXT = 'assessments/UPDATE_TEXT'

export function updateAnswersText(text,levelId,store) {
  return (dispatch,getState) => {
    
    let selectedAssessment = getState().selectedAssessment
    let answers = selectedAssessment.answers
    const activityId = getState().selectedActivity.id


    const found = answers.find( answer => answer.activityId === activityId && answer.levelId === levelId)
    if (found) {
        answers = answers.map( answer => {
            if (answer.activityId === activityId && answer.levelId === levelId) {
                answer.text = text
            }
            return answer
        })
    }
    selectedAssessment.answers = answers
    store.firestore.update({ collection:'assessmentsByRater', doc: selectedAssessment.id },{answers})
    .catch(error => {
      dispatch({type: 'ERROR', levelId: levelId ,message: error })
    })

    dispatch({
      type: UPDATE_TEXT,
      assessment: selectedAssessment
    })
  }
}


// WEBPACK FOOTER //
// ./src/levels/actions.js